import { PositionType, SizeType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { dogHouseSpine } from '../../views/blocks/DogHouseBlockView';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { Container } from '../../../odie';

export type CrateBreakEffectOptions = {
  position: PositionType;
  size: SizeType;
};

/*
  Poof effect
*/
export class PoofEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly position: PositionType;
  private readonly size: SizeType;

  constructor(scene: GameScene, options: CrateBreakEffectOptions) {
    this.scene = scene;
    this.position = options.position;
    this.size = options.size;
  }

  public static assets() {
    return [dogHouseSpine];
  }

  public async execute() {
    // Play the animation.
    this._animate();

    // Wait only a frame, do not wait for the whole animation.
    await waitAFrame();
  }
  private async _animate() {
    const container = new Container();
    const spine = await this.createSpine(container);

    // Spawn the movie clip as an overlay entity.
    const entity = spawnOverlayEntity(
      this.scene,
      this.position,
      this.size,
      () => container,
    );

    // Play the animations
    await playSpineAnimation(spine, { animation: 'poof', loop: false });

    // Despawn overlay entity.
    despawnOverlayEntity(this.scene, entity);
  }

  private async createSpine(container: Container) {
    await spineLoader(dogHouseSpine.url);
    return new SpineView({
      superview: container.view,
      spinePath: dogHouseSpine.url,
      scale: 0.65,
    });
  }
}
